export default {
    init() {
        /**
         * Modify Quantity
         *
         * Increments or decrements quantity if one of th eroller buttons is clicked.
         *
         * @param field Quantity field
         * @param type String containing increment or decerement.
         */
        function modify_qty(field, type) {
            var value = parseInt(field.val());
            if (isNaN(value)) {
                value = 0;
            }
            if (type === 'increment') {
                field.val(value + 1);
            } else if (type === 'decrement' && value > 0) {
                field.val(value - 1);
            } else {
                field.val(value);
            }
            if (parseInt(field.attr('min')) > parseInt(field.val())) {
                field.val(field.attr('min'));
            }
        }

        function assign_qty_field_functions() {
            var quantity_fields = $('input.qty');
            if (quantity_fields.length) {
                quantity_fields.each(function () {
                    var qty = $(this);
                    var container = qty.parent();

                    qty.keydown(function (e) {
                        // Allow: backspace, delete, tab, escape, enter and .
                        if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 110]) !== -1 ||
                            // Allow: Ctrl+A, Command+A
                            (e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true)) ||
                            // Allow: home, end, left, right, down, up
                            (e.keyCode >= 35 && e.keyCode <= 40)) {
                            // let it happen, don't do anything
                            return;
                        }
                        // Ensure that it is a number and stop the keypress
                        if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
                            e.preventDefault();
                        }
                    });

                    qty.on('blur', function () {
                        var qty = $(this);
                        var value = qty.val();
                        if (isNaN(value) || value == '') {
                            qty.val('0');
                        }
                        $( '.woocommerce-cart-form :input[name="update_cart"]' ).prop( 'disabled', false );
                    });

                    container.find('.increment').click(function (e) {
                        e.preventDefault();
                        modify_qty($(this).parent().find('input'), 'increment');
                        $( '.woocommerce-cart-form :input[name="update_cart"]' ).prop( 'disabled', false );
                    });
                    container.find('.decrement').click(function (e) {
                        e.preventDefault();
                        modify_qty($(this).parent().find('input'), 'decrement');
                        $( '.woocommerce-cart-form :input[name="update_cart"]' ).prop( 'disabled', false );
                    });
                });
            }
        }

        assign_qty_field_functions();

        $(document.body).on('updated_wc_div', function () {
            assign_qty_field_functions();
        });
    },
    finalize() {
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/cart.js